import "./LogoutPage.scss";
import "@mshop-ui/core-web-components/dist/ui-button";
import PropTypes from "prop-types";
import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import { withIntlRoot } from "../IntlRootMixin";
import { FormattedMessage } from "react-intl";
import { LogoutAction } from "../uidispatcherapi/SessionStore";

class LogoutPageComponent extends React.Component {
	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	componentDidMount() {
		LogoutAction.trigger();
	}

	render() {
		return (
			<div className="mfcss_wrapper logout-page">
				<center>
					<h1>
						<FormattedMessage id="PL_LOGOUT_PAGE" />
					</h1>
					<h5>
						<FormattedMessage id="PL_DESCRIPTION_LOGOUT_PAGE" />
					</h5>
					<LinkContainer to="/">
						<ui-button>
							<button className="test-return-to-homepage" data-variant="action">
								<FormattedMessage id="PL_RETURN_TO_HOMEPAGE" />
							</button>
						</ui-button>
					</LinkContainer>
				</center>
			</div>
		);
	}
}

export const LogoutPage = withIntlRoot(LogoutPageComponent);
